import Section from './PeelNStickSection'
import isEmpty from './PeelNStickIsEmpty'

export default { Section, isEmpty }
